import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, BookOpen, Brain, CheckCircle, Heart, Clock, User, Sparkles } from "lucide-react";
import { useLanguage } from "../../App";

const BottomNav = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const isEnglish = language === "en";

  // Desktop nav items (all)
  const desktopNavItems = [
    { path: "/home", icon: Home, label: isEnglish ? "Home" : "Beranda", testId: "home" },
    { path: "/quran", icon: BookOpen, label: isEnglish ? "Quran" : "Quran", testId: "quran" },
    { path: "/vocabulary", icon: Sparkles, label: isEnglish ? "Vocab" : "Kosakata", testId: "vocabulary" },
    { path: "/hafalan", icon: Brain, label: isEnglish ? "Memorize" : "Hafalan", testId: "hafalan" },
    { path: "/habits", icon: CheckCircle, label: isEnglish ? "Habits" : "Kebiasaan", testId: "habits" },
    { path: "/doa", icon: Heart, label: isEnglish ? "Duas" : "Doa", testId: "doa" },
    { path: "/prayer-times", icon: Clock, label: isEnglish ? "Prayer" : "Shalat", testId: "prayer-times" },
    { path: "/settings", icon: User, label: isEnglish ? "Settings" : "Pengaturan", testId: "settings" },
  ];

  // Mobile nav items (replace prayer-times and doa with user profile)
  const mobileNavItems = [
    { path: "/home", icon: Home, label: isEnglish ? "Home" : "Beranda", testId: "home" },
    { path: "/quran", icon: BookOpen, label: isEnglish ? "Quran" : "Quran", testId: "quran" },
    { path: "/vocabulary", icon: Sparkles, label: isEnglish ? "Vocab" : "Kosakata", testId: "vocabulary" },
    { path: "/hafalan", icon: Brain, label: isEnglish ? "Memorize" : "Hafalan", testId: "hafalan" },
    { path: "/habits", icon: CheckCircle, label: isEnglish ? "Habits" : "Kebiasaan", testId: "habits" },
    { path: "/profile", icon: User, label: isEnglish ? "Profile" : "Profil", testId: "profile" },
  ];

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      {/* Desktop Nav Items - hidden on mobile */}
      {desktopNavItems.map((item) => {
        const isActive = location.pathname.startsWith(item.path);
        const Icon = item.icon;

        return (
          <NavLink
            key={item.path}
            to={item.path}
            className={`nav-item desktop-only ${isActive ? "nav-item-active" : "text-muted-foreground"}`}
            data-testid={`nav-${item.testId}`}
          >
            <Icon className="w-6 h-6" strokeWidth={isActive ? 2.5 : 2} />
            <span className="text-xs font-medium">{item.label}</span>
          </NavLink>
        );
      })}

      {/* Mobile Nav Items - hidden on desktop */}
      {mobileNavItems.map((item) => {
        const isActive = location.pathname.startsWith(item.path);
        const Icon = item.icon;

        return (
          <NavLink
            key={item.path}
            to={item.path}
            className={`nav-item mobile-only ${isActive ? "nav-item-active" : "text-muted-foreground"}`}
            data-testid={`nav-${item.testId}`}
          >
            <Icon className="w-6 h-6" strokeWidth={isActive ? 2.5 : 2} />
            <span className="text-xs font-medium">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default BottomNav;
